export const STORIES_LIST_CONSTS = {
  clearFilters: 'Сбросить фильтры',
  create: 'Создать сюжет',
  createDateFrom: 'Начало периода создания',
  createDateTo: 'Конец периода создания',
  searchByDate: 'Поиск по дате',
  searchByTitle: 'Поиск по заголовку...',
  publicStories: 'Публикации',
  incutsStories: 'Врезки',
}
